import { cognitoDomain, clientId, logoutUri } from "../config/auth.config";

export const signOutRedirect = () => {
  try {
    localStorage.clear();
    // Clear stored authentication data.
    sessionStorage.clear();
    // Construct the Cognito logout URL with the required parameters
    const cognitoLogoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${logoutUri}`;
    // Redirect to Cognito logout page
    window.location.href = cognitoLogoutUrl;
  } catch (error) {
    console.error("Error during sign out:", error);
    // If cognitoLogoutUrl fails, fallback to basic logout.
    window.location.href = "/login";
  }
};
